module.exports = __webpack_public_path__ + "static/media/datasheet_entData_row2_certificate.6443c2fd.png";